import { Typography } from "antd";

const { Text } = Typography;

function LoyaltyDetailMetaField({ label, children }) {
  return (
    <span className="loyalty-detail-meta-field">
      <Text strong className="loyalty-detail-meta-label">
        {label}
      </Text>
      <Text className="loyalty-detail-meta-value">{children}</Text>
    </span>
  );
}

export default LoyaltyDetailMetaField;
